import { useAccount } from 'wagmi'

export const useAccountSafely = () => useAccount()
